/**
 * PLUGIN-KERNEL — mounts the app's composition and re-mounts it whenever the
 * active account changes.
 */
import { createMemo, onCleanup, type ParentComponent } from "solid-js";
import { Kernel, KernelContext } from "@fleet/kernel";
import { appComposition, type AppContribution, type HostServices } from "@/composition";
import { useI18n } from "@/providers/i18n-provider";

export const KernelProvider: ParentComponent = (props) => {
  const { t } = useI18n();

  const host: HostServices = {
    db: () => null,
    drizzle: () => null,
    userId: () => undefined,
    onHistoryError: () => {},
    translate: t,
  };

  const isTauri = typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
  const target = isTauri ? "tauri" : "web";
  const kernel = new Kernel<AppContribution>();

  const mounted = createMemo(() => {
    const app = kernel.mount(appComposition(host, target), { accountId: null });
    onCleanup(() => app.unmount());
    return app;
  });

  return <KernelContext.Provider value={mounted}>{props.children}</KernelContext.Provider>;
};
